/* globals Promise */
// import client from './client';
import lscache from 'lscache';
import store from '@/store';
import contentAreaMap from '@/contentful/content-area-map';
import defaultContent from '@/lang/content/global.content.lang';
// import getAsset from './get-asset';
lscache.setBucket('content');

function fetchContentAreas(contentAreaSlug) {

  return new Promise((resolve, reject) => {

    contentAreaMap.getContentAreaMap().then((map) => {

      let contentArea = map[contentAreaSlug];

      let user = store.getters.user,
          groupId = user ? user.groupNumber : null,
          provider = user && user.distributionPartnerCode ? user.distributionPartnerCode.toLowerCase() : null,
          entry = null,
          envDpc = process.env.VUE_APP_CLIENT_DPC;

      if (contentArea) {
        if (groupId && contentArea.fields['group_' + groupId]) {
          entry = contentArea.fields['group_' + groupId];
        } else if (provider && contentArea.fields['dpc_' + provider]) {
          entry = contentArea.fields['dpc_' + provider];
        } else if (envDpc && contentArea.fields['dpc_' + envDpc]) {
          entry = contentArea.fields['dpc_' + envDpc];
        } else {
          entry = contentArea.fields.default_content;
        }

        resolve(entry);

      } else {
        // Resolve to swallow the error, but this shouldn't happen with backup content
        resolve();
      }
    }).catch((e) => {
      reject(e);
    });
  });
}

export default function getContentArea(contentAreaSlug) {
  return new Promise( (resolve) => {

    if (Array.isArray(contentAreaSlug)) {
      let contentAreas = [];

      contentAreaSlug.forEach((slug) => {
        contentAreas.push(fetchContentAreas(slug));
      });

      Promise.all(contentAreas).then((data) => {
        resolve(data);
      }).catch((data) => {
        resolve(data);
      });

    } else {

      fetchContentAreas(contentAreaSlug).then((data) => {
        resolve(data);
      }).catch(() => {
        if (defaultContent[contentAreaSlug]) {
          resolve(defaultContent[contentAreaSlug]);
        } else {
          resolve(false);
        }
      });

    }
  });
}